import { CRUDEntity } from "../abstracts/CRUDEntity";

export class InvoiceItem extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'item';
        this.urlRoot = '/price-book/item';
        this.sectionRootUrl = '/price-book';
        this.id = id;
    }
}